import axiosIns from '@/plugins/axios'

export default {
  getBreakdown(formulaItemId, date) {
    return axiosIns.get('/v2/eod_report/formula_item_expense_breakdowns', {
      params: { formula_item_id: formulaItemId, date },
    })
  },
}
